/*
* @Author: tengmaoqing
* @Date:   2018-05-01 16:37:05
* @Last Modified by:   tengmaoqing
* @Last Modified time: 2018-07-02 19:20:58
*/

import accounting from 'accounting';

export const fen2yuan = (number, options = {}) => {
  const formatter = {
    symbol: '￥',
    thousand: ',',
    decimal: '.',
    format: '%s%v',
    divider: 100,
    precision: 2
  };

  if (options.precision === 'auto') {
    let arr = `${number / (options.divider || formatter.divider)}`.split('.');
    options.precision = arr[1] ? arr[1].length : 0;
  }

  const currency = Object.assign(formatter, options);
  if (currency.decimalDigits) {
    currency.precision = currency.decimalDigits;
  }
  let p = (number >>> 0) / formatter.divider;
  return accounting.formatMoney(p, currency);
};

export const trim = str => str.trim();

// export const superEncode = url => {
//   return encodeURI(url).replace('(', '%28').replace(')', '%29');
// };



// WEBPACK FOOTER //
// ./src/helper/filters.js